var _symbol, _symbol2, _symbol3, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 130 180",
    viewBox: "0 0 130 180",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "z",
    viewBox: "-11.5 -181.65 119 179.2"
  }, /*#__PURE__*/React.createElement("use", {
    x: -11.5,
    y: -181.65,
    width: 119,
    height: 179.2,
    xlinkHref: "#aa"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "aa",
    clipRule: "evenodd",
    fillRule: "evenodd",
    viewBox: "-11.5 -181.65 119 179.2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "102.75 -88.95 100 -181.3 7.15 -181.3 5.45 -111 -6.75 -76.25 -6.35 -29.4 -0.05 -9.2 93.15 -29.35 88.75 -54.15",
    fill: "#5A4239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.4-158.7c0.233-0.066 0.383-0.2 0.45-0.4-0.3-0.367-0.55-0.566-0.75-0.6-0.167 0.034-0.283 0.05-0.35 0.05-0.1 0.033-0.15 0.167-0.15 0.4 0 0.067 0.133 0.15 0.4 0.25 0.267 0.133 0.4 0.233 0.4 0.3z",
    fill: "#E0D7CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.3-73.1l-21.1-1.55-2.2 1.55-0.15 0.25 0.15-0.1 24.3 1.65-1-1.8zm9.7-27.15l-26.1-4.45 1.15 2.15v-0.05l0.05 0.05 23.05 3.85v0.05l1.85-1.6zm-23.1 18.4l-1.35 1.4 11.7 1.1-0.55-1.5-9.85-0.8 0.05-0.2zm14-11.3l-0.1 0.25 2.75-2.4-15.6-2.35-0.05 0.15 1.4 2.75 0.05-0.25 0.05 0.1 11.5 1.6v0.15z",
    fill: "#37261F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.1-98.4l-1.85 1.3 0.05 0.1-6 23.9 1 1.8 0.1 0.05 6.7-27.15zm-31.1 25.3l8.05-29.45-1.15-2.15-0.05 0.05-9.35 33.85h0.15l2.2-2.05 0.15-0.25zm12.3-21.65l-1.4-2.75-5.15 19.3 0.1 0.05 2.65-2.25-0.05-0.05 3.85-14.3zm10.2 2.8l-2.8 11.1 0.55 1.5h0.1l3.45-13.55 0.1-0.25-1.4 1.2z",
    fill: "#6A5046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.1-102.55l-0.05-0.05v0.05l-8.05 29.45 2.2-1.55-0.05-0.05 6.85-25.4-0.9-2.45zm17.25 33.25h0.1l7.65-30.9-0.1-0.05-1.85 1.6-0.05 0.25-6.7 27.15-0.1-0.05 1.05 2zm-16.8-11.15l1.35-1.4 3.1-11.45-0.6-1.6-0.05-0.1-0.05 0.25-3.85 14.3 0.05 0.05 0.05-0.05zm12.9 3.6h0.5l4.65-18.45h-0.05l-2.75 2.4-3.45 13.55h-0.1l0.05 0.5 1.15 2z",
    fill: "#46342D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.65-70.8l27.7 1.5-1.05-2-24.3-1.65-0.15 0.1-2.2 2.05zm11.35-29.3l0.15-0.25 20.1 3.25 1.85-1.3 0.05-0.25v-0.05l-23.05-3.85 0.9 2.45zm-0.5 19.7l-2.65 2.25 15.6 1.3-1.15-2-0.05-0.5-11.7-1.1-0.05 0.05zm4.5-12.9v-0.15l9.6 1.25-0.1 0.25 1.4-1.2v-0.15l-11.5-1.6 0.6 1.6z",
    fill: "#72594F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.6-174.1h-0.05v56.45l1.7-1.75h-0.05v-52.25l-1.6-2.45zm27-2.1l-1.6 2.15v56.6h-0.1l1.7 2.15h0.1v-60.9h-0.1zm-20.65 50.25l1.05-1.7v-37.5l-1.1-1.65h-0.1v40.85h0.15zm14.35 2.6h0.5v-46.1h-0.05l-2.3 3.1v40.4h-0.15l0.15 0.45 1.85 2.15z",
    fill: "#46342D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.25-171.9h0.1v52.5l1.55 1.95h0.1v-56.45l-1.75 2zm-25.25 56.6l1.6-2.15h-0.05v-56.6l-1.65-2.15h-0.05v60.9h0.15zm7.85-10.65h-0.05v-40.65l-2.05-2.75v46h0.15l1.95-2.6zm11.4-39.1v37.6l1.05 1.5h0.15v-40.65l-1.2 1.55z",
    fill: "#6A5046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18-115.3h28.6l-1.7-2.15h-25.3l-1.6 2.15zm25.25-56.6l1.75-2v-0.2h-25.4l1.6 2.45v-0.25h22.05zm-2.95 48.55l-1.85-2.15-0.15-0.45h-12.45l-1.95 2.6h16.4zm-3.05-41.7l1.2-1.55v-0.2h-12.55l1.1 1.65v-0.15h10.25v0.25z",
    fill: "#72594F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.35-119.4h-22.1l-1.7 1.75v0.2h25.35l-1.55-1.95zm3.25-56.8h-28.7l1.65 2.15v-0.05h25.45v0.05l1.6-2.15zm-20.7 9.4h12.55v0.45l2.3-3.1h-17v0.1l2.05 2.75v-0.2h0.1zm1.1 39.15l-1.05 1.7h12.35l-1.05-1.5h-10.25v-0.2z",
    fill: "#37261F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.1-38.9l0.05-0.05 24.15-3.45-1.55-1.15-21.15 3.1-0.05 0.05-1.45 1.35v0.15zm23.45-26.05l-27.45 4.05 1.75 1.15v-0.05h0.05l24.25-3.5v0.05l1.4-1.7zm-5.15 5.35l-16.2 2.35v0.1l2.15 1.4v-0.1h0.1l11.9-1.75 0.1 0.15v0.2l1.95-2.35zm-11.95 12.9l-0.9 1.25 11.85-1.7-1.1-0.85-9.85 1.45v-0.15z",
    fill: "#37261F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.1-39.05l-2.25-20.7-1.75-1.15h-0.05l2.55 23.65 0.15-0.05 1.35-1.6v-0.15zm22.05-24.05l-1.5 1.5 0.1-0.05 2 18.1 1.55 1.15h0.1l-2.25-20.7zm-18.3 19.7l1.6-2.05h-0.05l-1.05-10.3-2.15-1.4 1.5 13.8 0.15-0.05zm11.55-12.85l0.9 8.25 1.1 0.85h0.15l-1.1-10.1v-0.2l-1.05 1.2z",
    fill: "#6A5046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.75-37.3l27.35-4-1.8-1.1-24.15 3.45-0.05 0.05-1.35 1.6zm5.1-6.1l15.65-2.3-1.9-1.1-0.2-0.35-11.85 1.7h-0.1l-1.6 2.05zm-5.95-16.4l1.65 1.45v-0.2l21.1-3.05 1.5-1.5v-0.2l-24.25 3.5zm17.5 3.55l1.05-1.2-0.1-0.15-11.9 1.75 1.1 0.95v-0.1l9.8-1.45 0.05 0.2z",
    fill: "#72594F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.55-58.35l-1.65-1.45h-0.05v0.05l2.25 20.7 1.45-1.35-2-17.95zm6.9 11.65l-0.9-8.2-1.1-0.95h-0.1v0.1l1.05 10.3h0.15l0.9-1.25zm10.95-0.45l0.2 0.35 1.9 1.1 0.5-0.1-1.55-13.8h-0.05l-1.95 2.35 1.1 10.1h-0.15zm6.9 4.75l1.8 1.1h0.1l-2.55-23.65h-0.1l-1.4 1.7v0.15l2.25 20.7h-0.1z",
    fill: "#46342D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.15-169.45l-2.3 3.1v40.4h-0.15l0.15 0.45 1.85 2.15h0.5v-46.1h-0.05zm-14.8 43.5l1.05-1.7v-37.5l-1.1-1.65h-0.1v40.85h0.15zm-6.35-48.15h-0.05v56.45l1.7-1.75h-0.05v-52.25l-1.6-2.45zm27-2.1l-1.6 2.15v56.6h-0.1l1.7 2.15h0.1v-60.9h-0.1z",
    fill: "#46342D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.7-125.95h-12.45l-1.95 2.6h16.4l-1.85-2.15-0.15-0.45zm-20.3 10.65h28.6l-1.7-2.15h-25.3l-1.6 2.15zm19.25-49.75l1.2-1.55v-0.2h-12.55l1.1 1.65v-0.15h10.25v0.25zm6-6.85l1.75-2v-0.2h-25.4l1.6 2.45v-0.25h22.05z",
    fill: "#72594F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.65-165.05v37.6l1.05 1.5h0.15v-40.65l-1.2 1.55zm-11.4 39.1h-0.05v-40.65l-2.05-2.75v46h0.15l1.95-2.6zm17.4-45.95h0.1v52.5l1.55 1.95h0.1v-56.45l-1.75 2zm-23.7 54.25v-56.4l-1.65-2.15h-0.05v60.9h0.15l1.6-2.15h-0.05v-0.2z",
    fill: "#6A5046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.3-166.8h12.55v0.45l2.3-3.1h-17v0.1l2.05 2.75v-0.2h0.1zm1.1 39.15l-1.05 1.7h12.35l-1.05-1.5h-10.25v-0.2zm-7.45 10v0.2h25.35l-1.55-1.95h-22.1l-1.7 1.75zm27.05-58.55h-28.7l1.65 2.15v-0.05h25.45v0.05l1.6-2.15z",
    fill: "#37261F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.15-50l-0.15-0.05 0.05 0.15 0.9 12.6h0.05l0.05-0.05 1.15-1.6-0.8-9.85-1.25-1.2zm-6.2-3.5l-2.15-1.95-0.05 0.05v0.05l1.9 26.95 2.1-2.1h-0.1l-1.7-23zm21.9 14.85l0.4-0.15-1.2-14.6-1.95 2.3 0.9 10.95-0.15 0.05 0.2 0.35 1.8 1.1zm3.7-19.7l-1.2 1.55v0.15l1.8 21-0.1 0.05 1.55 0.95 0.05 0.05-2.05-23.75h-0.05z",
    fill: "#46342D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.75-34.6l2.25-2.7h-0.05l-0.9-12.6-2.7-1.95 1.25 17.3 0.15-0.05zm-5.1 6.4v-0.2l-1.9-26.95-2.35-1.75h-0.05l2.05 31.55 0.2-0.1 2.05-2.55zm18.4-21.85l0.75 9 1.05 0.95 0.15-0.05-0.9-10.95 0.05-0.15-1.1 1.2zm5-5.25l0.1 0.05 1.55 18.65 1.35 1 0.1-0.05-1.8-21-1.3 1.35z",
    fill: "#6A5046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.05-53.4l-17.65 1.45-0.05 0.1 2.7 1.95-0.05-0.15 0.15 0.05 12.95-1.4 0.05 0.15-0.05 0.15 1.95-2.3zm3.65 16.8l-22.95 6.1-2.1 2.1v0.2l0.05-0.05 26.35-7.35-1.35-1zm0.85-21.75l-30.15 1.25 2.35 1.75v-0.05l0.05-0.05 26.5-1.4 0.05 0.05 1.2-1.55zm-5.7 18.25l-1.05-0.95-10.6 2.3v-0.2l-1.15 1.6 12.8-2.75z",
    fill: "#37261F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.75-34.6l17.1-4.05-1.8-1.1-0.2-0.35-12.8 2.75-0.05 0.05-2.25 2.7zm-4.8-18.9l0.05-0.25 23.05-1.55 1.3-1.35v-0.15l-0.05-0.05-26.5 1.4 2.15 1.95zm-2.35 27.85l30-9-1.55-0.95-26.35 7.35-0.05 0.05-2.05 2.55zm20.45-24.4l1.1-1.2-0.05-0.15-12.95 1.4 1.25 1.2-0.05-0.15 10.7-1.3v0.2z",
    fill: "#72594F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.25-100.6l-1.55 1.6-0.05 0.2-3.15 24.1-0.05 0.05 1.15 1.65 0.1-0.1 3.65-27.45-0.1-0.05zm-22.95 0.2l-4.15 26.35 1.75-1.55v-0.1l3.45-22.65-1.05-2.05zm2.75 19.2l1.15-1.35 1.6-10.2-0.75-1.4-0.05-0.05v0.2l-2 12.8v0.05l0.05-0.05zm12.15 1.95l0.5-0.05 2.2-16.4-2.25 2.35-1.6 12h-0.1v0.45l1.25 1.65z",
    fill: "#46342D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.95-102.15l1.3 1.75h0.05l21.4 1.3v0.1l1.55-1.6-24.3-1.55zm19.5 27.5l-1.1-1.55-19.45 0.6-1.75 1.55-0.15 0.2 0.1-0.1 22.35-0.7zm-2.75-18.95l-0.05 0.25 2.25-2.35-14.45-0.6-0.05 0.1 1.6 2.2v-0.2l0.05 0.05 10.65 0.45v0.1zm-11.5 11.05l-1.15 1.35 10.9-0.15-0.75-1.2-9 0.2v-0.2z",
    fill: "#37261F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53-73.85l-1.75 1.95 25.35-1.1-1.15-1.65-22.35 0.7-0.1 0.1zm24.2-23.65l1.45-1.3 0.05-0.2v-0.1l-21.4-1.3 1.05 2.05 0.15-0.2 18.65 1.1 0.05-0.05zm-19.3 18.5l14.3-0.25-1.25-1.65v-0.45l-10.9 0.15-0.05 0.05-2.1 2.15zm4.9-13.75v-0.1l8.8 0.2-0.05 0.25 1.15-1.2v-0.1l-10.65-0.45 0.75 1.4z",
    fill: "#72594F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.2-82.55l0.75 1.2h0.1l1.6-12 0.05-0.25-1.15 1.2-1.35 9.85zm7-14.95l-2.85 21.3 1.1 1.55 0.05-0.05 3.15-24.1-1.45 1.3zm-24.05 23.45l4.15-26.35h-0.05l-1.3-1.75h-0.05l-4.8 30.35 0.15-0.1 1.75-1.95 0.15-0.2zm8.85-19.95l-1.6-2.2-2.55 17.15 0.05 0.05 2.1-2.15v-0.05l2-12.8z",
    fill: "#6A5046"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 41.537,
    x2: 51.81,
    y1: 97.491,
    y2: -188.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.4,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "102.75 -88.95 100 -181.05 7.15 -181.05 5.45 -111 -6.75 -76.25 -6.35 -29.4 -0.05 -9.2 93.15 -29.35 88.75 -54.15",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 93.35,
    x2: 85.997,
    y1: -66.035,
    y2: -68.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#160C00",
    stopOpacity: 0.2392,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "72.2 -49.55 88.6 -50.5 99.95 -83 99.95 -87.55 90.55 -87.7 86 -87.75 72.1 -49.8",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 102.18,
    x2: 92.983,
    y1: -134.58,
    y2: -134.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#160C00",
    stopOpacity: 0.2392,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "90.55 -87.7 99.95 -87.55 99.95 -181.55 90.55 -181.55",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 91.933,
    x2: 84.156,
    y1: -41.981,
    y2: -39.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#160C00",
    stopOpacity: 0.2392,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "88.6 -50.5 72.2 -49.55 80.25 -25 95.2 -28.55 88.9 -50.5",
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: -2652.5,
    x2: -2641,
    y1: -3497,
    y2: -3497,
    gradientTransform: "matrix(.9326 -.3609 .4185 .9103 3938.5 2206.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#160C00",
    stopOpacity: 0.2392,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "11.15 -34.55 -6.65 -30.25 3.1 -7.55 19.35 -13.75",
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: -2.5,
    x2: 8.3,
    y1: -53.4,
    y2: -53.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#160C00",
    stopOpacity: 0.2392,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "-6.65 -30.25 11.15 -34.55 14.1 -59.4 15.55 -71.9 -5.15 -76.4 -5.9 -76.55 -7.4 -32",
    fill: "url(#v)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 8.1626,
    x2: 15.138,
    y1: -120.47,
    y2: -120.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#160C00",
    stopOpacity: 0.2392,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m23.15-105.65l-7.6 33.75-1.45 12.5h9.05v-46.25zm-14.4-6.2l14.4 4.3v-74h-14.4v69.7z",
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 2394,
    x2: 2405,
    y1: 1530.8,
    y2: 1530.8,
    gradientTransform: "matrix(.9743 .2254 -.2636 .9654 -1926.5 -2111.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#160C00",
    stopOpacity: 0.2392,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "-5.15 -76.4 15.55 -71.9 23.15 -105.65 23.15 -107.55 8.75 -111.85 7 -112.55",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 1804.2,
    x2: 1808.1,
    y1: -17837,
    y2: -17837,
    gradientTransform: "matrix(-.2319 -.9727 .9808 -.198 17958 -1800.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#160C00",
    stopOpacity: 0.2392,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m94.55-29.15l-2.4-9.85c-2.566-1.133-6.333-1.417-11.3-0.85l-72.15 14.6c-0.733 0.3-2.934-0.667-6.6-2.9-2.167 4.767-4.3 8.467-6.4 11.1l1.9 7.9 96.95-20z",
    fill: "url(#y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.75-181.65h-0.5v67.65l-11.45 34.9c-0.066 0.1-0.1 0.2-0.1 0.3l-1.2 49.65c0 0.133 0.033 0.25 0.1 0.35l-0.05-0.05 7.1 26.2c0.033 0.067 0.083 0.117 0.15 0.15 0.034 0.033 0.083 0.05 0.15 0.05l101.8-22.75c0.167 0 0.333-0.083 0.5-0.25 0.1-0.1 0.2-0.233 0.3-0.4v-0.05c0.034-0.167 0.034-0.333 0-0.5v-0.05l-6.1-23.7 11.7-35.75v-0.25l3.35-95.5h-0.5l-3.35 95.5v0.1l-11.75 35.8v0.15l6.15 23.8c0.034 0.1 0.034 0.2 0 0.3-0.033 0.1-0.083 0.167-0.15 0.2-0.066 0.066-0.133 0.1-0.2 0.1h-0.05l-101.55 22.7-7.05-26c-0.033-0.033-0.05-0.083-0.05-0.15l1.2-49.65c0-0.034 0.017-0.067 0.05-0.1v-0.05l11.5-35v-67.7z",
    fill: "#fff",
    fillOpacity: 0.102
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.85-181.65h-3.1v67.7l-11.5 35v0.05c-0.033 0.033-0.05 0.066-0.05 0.1l-1.2 49.65c0 0.066 0.017 0.117 0.05 0.15l7.05 26 101.55-22.7h0.05c0.066 0 0.133-0.033 0.2-0.1 0.067-0.034 0.117-0.1 0.15-0.2 0.034-0.1 0.034-0.2 0-0.3l-6.15-23.8v-0.15l11.75-35.8v-0.1l3.35-95.5h-2.75c0.067 0.033 0.15 0.05 0.25 0.05h1.25l-3.35 95.25-11.75 35.95c-0.066 0.133-0.066 0.267 0 0.4l5.9 23.05 0.1 0.25-100 21.85v-0.05l-6.4-24.3 1.2-49.4 11.55-35.05v-67.95h1.6c0.1 0 0.183-0.017 0.25-0.05z",
    fillOpacity: 0.4824
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.05-27.85l-97.2 21.35-0.25 0.1-0.95 1.5v0.05l100-21.85-0.1-0.25-1.5-0.9zm7.65-153.8h-2.75l-3.1 93.75-11.85 37.95 3.85 16.25 0.2 1 2.7-0.55-4.25-16.4 12-37.5 3.2-94.5z",
    fill: "#735245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.5-181.6l-3.25 94.9-11.95 36.7 5.75 22.15 1.5 0.9-5.9-23.05c-0.066-0.133-0.066-0.267 0-0.4l11.75-35.95 3.35-95.25h-1.25z",
    fill: "#46332B"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.05 -32.7 88.85 -33.7 2.3 -14.65 -2.55 -30.95 -1.65 -76.5 9.55 -111.1 9.2 -147.15 8.9 -112 -2.6 -76.8 -3.65 -30.5 0.85 -13.25 89.1 -32.6",
    fillOpacity: 0.3686
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-2.15-6.5l97.2-21.35-5.75-22.15 11.95-36.7 3.25-94.9c-0.1 0-0.183-0.017-0.25-0.05h-1.55l-3.2 94.5-12 37.5 4.25 16.4-2.7 0.55 0.05 0.1-88.25 19.35-4.5-17.25 1.05-46.3 11.5-35.2 0.3-35.15-0.05-34.5h-4.3c-0.067 0.033-0.15 0.05-0.25 0.05l-0.1 68.4-11.55 35.1-1.15 48.5 6.05 23.1z",
    fill: "#5A4239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-3.35-4.9l0.95-1.5 0.25-0.1-6.05-23.1 1.15-48.5 11.55-35.1 0.1-68.4h-1.6v67.95l-11.55 35.05-1.2 49.4 6.4 24.3z",
    fill: "#49342C"
  }), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.3608
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "41.875 -52.625 43.95 -58.25 43.775 -58.5 40.9 -62.45 38.1 -60.95 37.7 -60.75 40.1 -57.425 40.275 -57.175 38.225 -51.875 38.05 -51.4 40 -48.65 40.45 -48 37.475 -47.275 36.7 -47.1 43.2 -42.3 47.95 -49.1 47.375 -49.025 44.15 -48.55 41.7 -52.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.375-49.025l0.575-0.825-3.8 0.55-2.275-3.325-0.175 0.475 2.45 3.6 3.225-0.475zm-9.9 1.75l2.975-0.725-0.45-0.65-3.3 0.8 0.775 0.575zm0.75-4.6l2.05-5.3-0.175-0.25-2.05 5.275 0.175 0.275zm-0.125-9.075l2.8-1.5 2.875 3.95 0.175-0.5-3.05-4.2-3.2 1.7 0.4 0.55z",
    fill: "#FFE0A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 87.5,
    cy: -99.7,
    r: 6.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B585",
    offset: 0.0588
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#816943",
    offset: 0.3922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#503712",
    offset: 0.9882
  })), /*#__PURE__*/React.createElement("path", {
    d: "m94.85-101.85v-0.35c0-1.4-0.533-2.633-1.6-3.7-1.033-1.033-2.267-1.55-3.7-1.55-1 0-1.85 0.217-2.55 0.65-0.433 0.233-0.85 0.533-1.25 0.9-0.367 0.4-0.667 0.816-0.9 1.25-0.367 0.767-0.55 1.583-0.55 2.45 0 1.5 0.483 2.767 1.45 3.8 1.067 1 2.333 1.5 3.8 1.5 1.434 0 2.667-0.5 3.7-1.5 0.567-0.6 0.983-1.25 1.25-1.95 0.167-0.467 0.283-0.967 0.35-1.5zm-1.6 1.9c-0.2 0.333-0.417 0.6-0.65 0.8-0.867 0.833-1.883 1.25-3.05 1.25-1.2 0-2.216-0.417-3.05-1.25-0.833-0.8-1.25-1.783-1.25-2.95v-0.1c0-0.633 0.15-1.233 0.45-1.8 0.033-0.2 0.133-0.417 0.3-0.65 0.1-0.167 0.267-0.367 0.5-0.6 0.833-0.8 1.85-1.2 3.05-1.2 1.167 0 2.184 0.4 3.05 1.2 0.767 0.833 1.15 1.85 1.15 3.05 0 0.767-0.167 1.483-0.5 2.15v0.1z",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 87.5,
    cy: -99.7,
    r: 6.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B585",
    offset: 0.0588
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A88857",
    offset: 0.3922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#665131",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m93.25-99.95v-0.1c0.333-0.667 0.5-1.383 0.5-2.15 0-1.2-0.383-2.216-1.15-3.05-0.867-0.8-1.883-1.2-3.05-1.2-1.2 0-2.216 0.4-3.05 1.2-0.233 0.233-0.4 0.433-0.5 0.6-0.167 0.233-0.267 0.45-0.3 0.65-0.3 0.567-0.45 1.167-0.45 1.8v0.1c0 1.167 0.417 2.15 1.25 2.95 0.833 0.833 1.85 1.25 3.05 1.25 1.167 0 2.184-0.417 3.05-1.25 0.233-0.2 0.45-0.467 0.65-0.8z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.85-104.65c0.233-0.434 0.533-0.85 0.9-1.25 0.4-0.367 0.817-0.667 1.25-0.9 0.7-0.434 1.55-0.65 2.55-0.65 1.434 0 2.667 0.517 3.7 1.55 1.067 1.066 1.6 2.3 1.6 3.7v0.35c0.1-0.167 0.183-0.367 0.25-0.6 0.2-0.533 0.3-1.133 0.3-1.8 0-1.433-0.517-2.667-1.55-3.7s-2.267-1.55-3.7-1.55c-1 0-1.867 0.217-2.6 0.65-0.433 0.2-0.833 0.5-1.2 0.9-0.9 0.933-1.4 2.033-1.5 3.3z",
    fillOpacity: 0.4784
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.95-99.45c0.267-0.6 0.4-1.267 0.4-2 0-1.2-0.383-2.216-1.15-3.05-0.867-0.833-1.883-1.25-3.05-1.25-1.2 0-2.217 0.417-3.05 1.25-0.033 0.067-0.083 0.117-0.15 0.15-0.1 0.233-0.184 0.467-0.25 0.7 0.833-0.767 1.816-1.15 2.95-1.15 1.167 0 2.167 0.4 3 1.2 0.8 0.9 1.2 1.917 1.2 3.05 0 0.466-0.05 0.883-0.15 1.25 0.066 0 0.117-0.034 0.15-0.1l0.1-0.05z",
    fillOpacity: 0.2667
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.95-104.35c0.066-0.033 0.117-0.083 0.15-0.15 0.833-0.833 1.85-1.25 3.05-1.25 1.167 0 2.184 0.417 3.05 1.25 0.767 0.833 1.15 1.85 1.15 3.05 0 0.733-0.133 1.4-0.4 2 0.7-0.833 1.05-1.833 1.05-3 0-1.2-0.383-2.216-1.15-3.05-0.867-0.8-1.883-1.2-3.05-1.2-1.2 0-2.216 0.4-3.05 1.2-0.333 0.4-0.6 0.783-0.8 1.15z",
    fillOpacity: 0.3608
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.1-102.45c0-1.4-0.517-2.633-1.55-3.7-1.066-1.033-2.316-1.55-3.75-1.55-0.966 0-1.816 0.217-2.55 0.65l-1 2.15c0.133-0.167 0.3-0.367 0.5-0.6 0.833-0.8 1.85-1.2 3.05-1.2 1.167 0 2.184 0.4 3.05 1.2 0.767 0.833 1.15 1.85 1.15 3.05 0 0.767-0.15 1.483-0.45 2.15l1.2-0.3c0.233-0.567 0.35-1.183 0.35-1.85z",
    fillOpacity: 0.4784
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "ab",
    viewBox: "-10.5 -186.65 119 179.2"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(1 -5)",
    x: -11.5,
    y: -181.65,
    width: 119,
    height: 179.2,
    xlinkHref: "#z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1 0 0 -1 14.85 -6.3999)",
    x: -10.5,
    y: -186.65,
    width: 119,
    height: 179.2,
    xlinkHref: "#ab"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/AboutUs.a8ffa233096375b07a905cd094b92ef3.svg";
export { ForwardRef as ReactComponent };